import { Card, CardBody, Col, Row } from "reactstrap";
import { Ribbon } from "../../../../AbstractElements";
import CommonCardHeader from "../../../CommonComponents/CommonCardHeader/CommonCardHeader";
import { RightSideRibbonTitle } from "../../../../Constants/Constants";
import { RightRibbonSubTitle, RightSideData } from "../../../../Data/BonusUi/Ribbons";

const RightSideRibbon = () => {
  return (
    <Row>
      <Col sm="12" xl="12">
        <Card>
          <CommonCardHeader title={RightSideRibbonTitle} span={RightRibbonSubTitle} />
          <CardBody>
            <Row className="g-3">
              {RightSideData &&
                RightSideData.map((item, index) => (
                  <Col xl="4" sm="6" key={index}>
                    <div className={item.classMain}>
                      <Ribbon className={item.ribbonClass}>{item.ribbonText}</Ribbon>
                      {item.subText}
                    </div>
                  </Col>
                ))}
            </Row>
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
};
export default RightSideRibbon;
